import { Component } from '@angular/core';

import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AideSupportService } from 'src/services/aide-support.service';
import { SnackBarService } from 'src/services/snack-bar.service';

@Component({
    selector: 'app-nous-contacter',
    templateUrl: './nous-contacter.component.html',
    styleUrls: ['./nous-contacter.component.scss'],
    imports: [
    FormsModule,
    MatIconModule,
    MatSnackBarModule,
    TranslateModule
]
})
export class NousContacterComponent {
  sujet: string = '';
  description: string = '';
  sujetTouched: boolean = false;
  descriptionTouched: boolean = false;
  isSubmitting: boolean = false;

  constructor(
    private router: Router,
    private snackBarService: SnackBarService,
    private translate: TranslateService,
    private aideSupportService: AideSupportService
  ) { }

  onSubmit(): void {
    this.sujetTouched = true;
    this.descriptionTouched = true;

    if (this.isFormValid() && !this.isSubmitting) {
      this.isSubmitting = true;

      this.aideSupportService.envoyerDemandeSupport(this.sujet, this.description).subscribe({
        next: () => {
          const successMessage = this.translate.instant('AIDE_ET_SOUTIEN.CONTACT_FORM.SUCCESS_MESSAGE');
          this.snackBarService.showMessage(successMessage, '', 5000);

          this.sujet = '';
          this.description = '';
          this.sujetTouched = false;
          this.descriptionTouched = false;
          this.isSubmitting = false;
        },
        error: (error) => {
          console.error('Erreur lors de l\'envoi de la demande de support:', error);

          const errorMessage = this.translate.instant('AIDE_ET_SOUTIEN.CONTACT_FORM.ERROR_MESSAGE') ||
            'Une erreur est survenue lors de l\'envoi de votre demande. Veuillez réessayer.';
          this.snackBarService.showMessage(errorMessage, '', 5000);

          this.isSubmitting = false;
        }
      });
    }
  }

  onCancel(): void {
    this.router.navigate(['/aide-et-soutien']);
  }

  isFormValid(): boolean {
    return this.sujet.trim().length > 0 &&
      this.sujet.length <= 200 &&
      this.description.trim().length > 0 &&
      this.description.length <= 2000;
  }

  isSujetInvalid(): boolean {
    return this.sujetTouched && (this.sujet.trim().length === 0 || this.sujet.length > 200);
  }

  isDescriptionInvalid(): boolean {
    return this.descriptionTouched && (this.description.trim().length === 0 || this.description.length > 2000);
  }

  getSujetErrorMessage(): string {
    if (this.sujet.trim().length === 0) {
      return this.translate.instant('AIDE_ET_SOUTIEN.CONTACT_FORM.ERROR_REQUIRED');
    }
    if (this.sujet.length > 200) {
      return this.translate.instant('AIDE_ET_SOUTIEN.CONTACT_FORM.ERROR_MAXLENGTH', { maxLength: 200 });
    }
    return '';
  }

  getDescriptionErrorMessage(): string {
    if (this.description.trim().length === 0) {
      return this.translate.instant('AIDE_ET_SOUTIEN.CONTACT_FORM.ERROR_REQUIRED');
    }
    if (this.description.length > 2000) {
      return this.translate.instant('AIDE_ET_SOUTIEN.CONTACT_FORM.ERROR_MAXLENGTH', { maxLength: 2000 });
    }
    return '';
  }
}
